import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import { shuffler } from "./Utils";

gsap.registerPlugin(Draggable);

class DragSequential {
  constructor(el, callback) {
    this.el = el;
    this.callback = callback;
    this.dragSequenceOverlapThreshold = "25%";
    this.dragSequenceContainer = document.querySelector(this.el);
    this.dragSequenceSoftwareElements = gsap.utils.toArray(
      ".js-draggables-sequence-mini > [data-id]"
    );
    this.dragSequenceDroppables =
      this.dragSequenceContainer.querySelectorAll(".draggable");
    this.dragSequenceDropZones =
      this.dragSequenceContainer.querySelectorAll(".dropzone");
    this.dragSequenceShuffleParent =
      this.dragSequenceContainer.querySelector(".js-shuffle");
    this.dragSequenceShuffleElems = [
      ...this.dragSequenceShuffleParent.querySelectorAll("div"),
    ];
    this.dragSequenceProductionLine =
      document.querySelector(".js-product-line");
    this.dragSequenceProductionLineEls =
      this.dragSequenceProductionLine.querySelectorAll("[data-name]");
    this.dragSequenceInsideZone = false;
    this.dragSequenceMatch = false;
    this.dragSequenceCurrentZone = null;
    this.dragSequenceMatchCount = 0;
    shuffler(this.dragSequenceShuffleParent, this.dragSequenceShuffleElems);
    this.that = this;
    this.init();
  }
  init() {
    this.dragSequenceDroppables.forEach((el) => {
      Draggable.create(el, {
        onDragParams: [this.that],
        onDragEndParams: [this.that],
        onDrag: function (parent) {
          parent.dragSequenceInsideZone = false;
          for (var i = 0; i < parent.dragSequenceDropZones.length; i++) {
            if (
              this.hitTest(
                parent.dragSequenceDropZones[i],
                parent.dragSequenceOverlapThreshold
              )
            ) {
              parent.dragSequenceInsideZone = true;
              parent.dragSequenceCurrentZone = parent.dragSequenceDropZones[i];

              // parent.dragSequenceMatch =
              //   parent.dragSequenceDropZones[i].getAttribute("data-id") ==
              //   this.target.getAttribute("data-id")
              //     ? true
              //     : false;

              //                 parent.dragSequenceMatch =
              // parent.dragSequenceDropZones[i].getAttribute("data-id") ==
              // this.target.getAttribute("data-id");

              parent.dragSequenceMatch =
                parent.dragSequenceDropZones[i].dataset.id ==
                this.target.dataset.id;

              break;
            }
          }
        },
        onDragEnd: function (parent) {
          if (!parent.dragSequenceInsideZone) {
            gsap.to(this.target, { duration: 0.2, x: 0, y: 0 });
          } else {
            if (!parent.dragSequenceMatch) {
              gsap.to(this.target, { duration: 0.2, x: 0, y: 0 });
            } else {
              // let id = this.target.getAttribute("data-id");
              let id = this.target.dataset.id;

              // parent.dragSequenceProductionLineEls.forEach((div) => {
              //   if (div.dataset.name == id) {
              //     let images = div.querySelectorAll("img");
              //     images[0].classList.add("hidden");
              //     images[1].classList.remove("hidden");
              //   }
              // });

              parent.dragSequenceProductionLineEls.forEach((div) => {
                if (div.dataset.name == id) {
                  let images = div.querySelectorAll("img"); // This query runs every time the loop hits this 'if' condition
                  images[0].classList.add("hidden");
                  images[1].classList.remove("hidden");
                }
              });

              parent.dragSequenceCurrentZone.classList.remove("glass-black");
              parent.dragSequenceCurrentZone.classList.add("!bg-se_green");

              // document
              //   .querySelectorAll(".js-draggables-sequence-mini > [data-id]")
              //   .forEach((el) => {
              //     let theID = el.getAttribute("data-id");
              //     if (theID == id) {
              //       el.classList.add("bg-se_green");
              //       el.textContent = theID;
              //     }
              //   });

              parent.dragSequenceSoftwareElements.forEach((el) => {
                let theID = el.getAttribute("data-id");
                if (theID == id) {
                  el.classList.add("!bg-se_green");
                  el.textContent = theID;
                  if(window.debug){ console.log(el); }
                }
              });

              parent.dragSequenceMatchCount = parent.dragSequenceMatchCount + 1;
              let obj = this.target.getBoundingClientRect();
              let zone = parent.dragSequenceCurrentZone.getBoundingClientRect();
              let x = "+=" + (zone.left - obj.left);
              let y = "+=" + (zone.top - obj.top);
              gsap.to(this.target, {
                duration: 0.3,
                x: x,
                y: y,
                opacity: 0,
                onComplete: () => {
                  if (parent.dragSequenceMatchCount == 5) {
                    parent.callback();
                  }
                  Draggable.get(this.target).disable();
                  parent.dragSequenceMatch = false;
                },
              });
            }
          }
        },
      });
    });
  }
  reset() {
    this.dragSequenceInsideZone = false;
    this.dragSequenceMatch = false;
    this.dragSequenceCurrentZone = null;
    this.dragSequenceMatchCount = 0;
    this.dragSequenceDroppables.forEach((el) => {
      gsap.set(el, { x: 0, y: 0, opacity: 1 });
      Draggable.get(el).enable();
    });
    this.dragSequenceProductionLineEls.forEach((div) => {
      let images = div.querySelectorAll("img");
      images[0].classList.remove("hidden");
      images[1].classList.add("hidden");
    });
    gsap.utils.toArray(".js-product-line > div").forEach((el) => {
      el.classList.remove("!bg-se_green");
      el.classList.add("glass-black");
    });
    this.dragSequenceSoftwareElements.forEach((el) => {
      el.classList.remove("!bg-se_green");
      el.textContent = el.dataset.default;
    });
  }
}

export { DragSequential };
